export enum PreSelectSection {
    PotentialDonors = 1,
    AvoidConflict = 2,
    InMatch = 3,
    BioMatch = 4,
    All = 5
}

export const PreSelectSectionDescription: { [key in PreSelectSection]: string } = {
    [PreSelectSection.PotentialDonors]: "Potential Donors",
    [PreSelectSection.AvoidConflict]: "Avoid Conflict",
    [PreSelectSection.InMatch]: "In Match",
    [PreSelectSection.BioMatch]: "Bio Match",
    [PreSelectSection.All]: "All"
}